import { useState } from "react";
import { Dialog, HamburgerIcon, theme, Typography } from "kosmos-ui";

import { useShopper } from "app/context/ShopperContext/hooks";
import { useLayout } from "app/context/LayoutContext/hooks";
import { useBackgroundLocation } from "app/hooks/routes";

import ShopperBrowserSidebar from "./components/ShopperBrowserSidebar";
import ShopperBrowserSectionSwitcher from "./components/ShopperSectionSwitcher";
import { TShopperBrowserSection } from "./types";
import { SHOPPER_BROWSER_SIDEBAR_SECTIONS } from "./constants";
import { ShopperBrowserActionsContainer, TransparentButton } from "./styles";

export default function ShopperBrowser() {
  const [showSidebar, setShowSidebar] = useState(false);
  const [activeSection, setActiveSection] =
    // TODO: Set 'home' as default section when recommendation service
    // is available
    useState<TShopperBrowserSection>("profile");

  const { goBackToBackgroundLocation } = useBackgroundLocation();

  const { mobile } = useLayout();

  const { shopper, loadingShopperData } = useShopper();

  function handleSectionChange(selectedSection: TShopperBrowserSection) {
    setShowSidebar(false);
    setActiveSection(selectedSection);
  }

  if (!shopper) {
    goBackToBackgroundLocation();

    return null;
  }

  const activeSectionLabel = SHOPPER_BROWSER_SIDEBAR_SECTIONS.find(
    (section) => section._id === activeSection
  )?.label;

  return (
    <Dialog
      show
      style={{
        width: mobile ? "75vw" : "35vw",
        backgroundColor: theme.colorsPalette.black.default,
      }}
    >
      <Dialog.Header style={{ marginBottom: 0 }}>
        <ShopperBrowserActionsContainer>
          <TransparentButton onClick={() => setShowSidebar((state) => !state)}>
            <HamburgerIcon
              height="20px"
              color={theme.colorsPalette.white.default}
            />
          </TransparentButton>

          <Typography
            as="h1"
            variant="paragraph2"
            style={{ color: theme.colorsPalette.white.default }}
          >
            {activeSectionLabel}
          </Typography>
        </ShopperBrowserActionsContainer>

        <Dialog.Close
          onClick={goBackToBackgroundLocation}
          style={{
            position: "absolute",
            right: 24,
            backgroundColor: "transparent",
          }}
        />
      </Dialog.Header>

      <Dialog.Body style={{ position: "relative", height: "60vh" }}>
        {loadingShopperData ? (
          <p>Cargando informacion de tu cuenta...</p>
        ) : (
          <>
            <ShopperBrowserSidebar
              show={showSidebar}
              activeSection={activeSection}
              onSectionChange={handleSectionChange}
            />

            <ShopperBrowserSectionSwitcher activeSection={activeSection} />
          </>
        )}
      </Dialog.Body>
    </Dialog>
  );
}
